import React from 'react';
import pt from 'prop-types';
import { MrInputText, MrIconTooltip } from '@ion/components';
import { Box, Stack } from '@metarouter-private/mr-mui';
import { DEFAULT_OPT_IN_VALUES } from 'app/components/analytics-builder/CONSENT_SOURCE_TYPES';
import { CONSENT_OPT_IN_VALUES } from 'app/components/analytics-builder/form-keys';
import { validateOptInValues } from '../consentOptInValues';
import s from './ConsentOptInValues.module.scss';

const TOOLTIP_MESSAGE =
  'The raw values your consent platform uses to mean "consented". When the built file reads a consent code\'s value — from the cookie or the JavaScript API — it compares it against this list: a match counts as opted-in, anything else as opted-out. For example, with opt-in values "1, true", a cookie entry of C0001:1 means C0001 is opted-in, while C0001:0 is opted-out.';

const TRANSCEND_TOOLTIP_MESSAGE =
  "Transcend boolean values are compared against this list. Auto indicates a provider default, so the named adapter uses the AJS file's explicit/implied default for that purpose regardless of this list. Global Privacy Control overrides still apply.";

export default function ConsentOptInValues({
  formState,
  setField,
  validateField,
  validateRequired,
  resetError,
  autoUsesAjsDefault = false,
}) {
  return (
    <Box mb={3}>
      {/*
        MrInputText's label prop only takes a string, so the label is rendered
        here to put the tooltip beside the text rather than beside the field —
        wrapping it in MrWithTooltip instead makes the container inline-flex,
        which shrinks the input. The field nests inside the label element,
        which associates the two without the id MrInputText does not expose.
      */}
      <label className={s.label}>
        <Stack direction="row" alignItems="center" spacing={1} className={s.labelRow}>
          <span className={s.labelText}>
            Opt-In Values <span className={s.required}>*</span>
          </span>
          <MrIconTooltip message={autoUsesAjsDefault ? TRANSCEND_TOOLTIP_MESSAGE : TOOLTIP_MESSAGE} />
        </Stack>
        <MrInputText
          onChange={setField}
          value={formState[CONSENT_OPT_IN_VALUES]?.value ?? DEFAULT_OPT_IN_VALUES}
          onBlur={validateField}
          onInput={resetError}
          name={CONSENT_OPT_IN_VALUES}
          errorMsg={formState[CONSENT_OPT_IN_VALUES]?.errorMsg}
          helperText={
            autoUsesAjsDefault
              ? "Boolean opt-in values, comma-separated or a JSON string array. [] means no values match. Auto always uses the AJS file's explicit/implied default."
              : 'Opt-in values, comma-separated or a JSON string array (case-insensitive). [] means no values match; missing codes still use the Consent Policy default.'
          }
          placeholder={DEFAULT_OPT_IN_VALUES}
          validators={[validateRequired(), validateOptInValues]}
          fullWidth
          required
        />
      </label>
    </Box>
  );
}

ConsentOptInValues.propTypes = {
  formState: pt.object.isRequired,
  setField: pt.func.isRequired,
  validateField: pt.func.isRequired,
  validateRequired: pt.func.isRequired,
  resetError: pt.func.isRequired,
  autoUsesAjsDefault: pt.bool,
};
